import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { labQKeys } from "@hooks/queries/lab/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateLab = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (lab: FormData) => {
      return api.post("lab/", lab, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      // console.log(res.data)
      showSuccessNotification({
        title: "success",
        message: "create-lab-success",
      });
      queryClient.invalidateQueries({
        queryKey: labQKeys.patient(variables.get("patient_id") as string),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.get("patient_id") as string),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Lab]", res);
      handleErrors(res, "mutation");
    },
  });
};
